import type { AccountServices } from '@/portal-api.definition';

type Service = AccountServices['Holder']['ServiceAccounts'][number];

export function groupServiceAccounts(services: Service[]): Service[] {
  const groupMap = new Map<string, Service>();

  for (const service of services) {
    const existing = groupMap.get(service.Id);
    if (existing) {
      groupMap.set(service.Id, {
        ...existing,
        Package: `${existing.Package} + ${service.Package}`,
        HasTvService: existing.HasTvService || service.HasTvService,
        HasInternetService: existing.HasInternetService || service.HasInternetService,
        Address: existing.Address || service.Address,
        MobileNumber: existing.MobileNumber || service.MobileNumber,
      });
    } else {
      groupMap.set(service.Id, { ...service });
    }
  }

  return [...groupMap.values()];
}
